import TextTransformer from "../html/TextTransformer";
import MorphologyLookup from "./MorphologyLookup";

export default class MorphologyTransformer implements TextTransformer {

    public constructor(private readonly morphology: MorphologyLookup) {
    }

    public transformText(text: string): string {
        const description = this.morphology.getDescription(text);
        return description !== '' ? description : '?';
    }
}
